import { filterSearchedChildren } from 'Components/widgets/contact-info/ContactInfoUtils';
import { get } from 'lodash';
import { resolve } from 'redux-optimist-promise';
import {
  FETCH_PROPOSALS_BY_ID,
  FETCH_PROPOSALS_FROM_EDIT_CRITERIA,
  FETCH_PROPOSALS,
} from 'Store/booking/proposals/constants';
export const ADD_TRAVEL_COMPANION = 'ADD_TRAVEL_COMPANION';
export const EDIT_TRAVEL_COMPANION = 'EDIT_TRAVEL_COMPANION';
export const SELECT_TRAVEL_COMPANION = 'SELECT_TRAVEL_COMPANION';
export const UNSELECT_TRAVEL_COMPANION = 'UNSELECT_TRAVEL_COMPANION';
type State = {
  list: Array<TravelCompanion>;
  selectedIndexes: Array<{
    index: number;
    position: number;
  }>;
};
const initialState: State = {
  list: [],
  selectedIndexes: [],
};
export const travelCompanionReducer = (state: State = initialState, action: Action<any>) => {
  switch (action.type) {
    case resolve(FETCH_PROPOSALS_BY_ID):
    case resolve(FETCH_PROPOSALS):
    case resolve(FETCH_PROPOSALS_FROM_EDIT_CRITERIA): {
      const attendees = get(action, 'payload.proposals.proposals.0.attendees', {});
      const { travelCompanions, selectedIndexes } = filterSearchedChildren(
        get(action, 'payload.profile.travelCompanions', []),
        attendees,
      );
      return {
        list: travelCompanions || [],
        selectedIndexes: selectedIndexes || [],
      };
    }

    case ADD_TRAVEL_COMPANION:
      state.list.push(action.payload);
      return state;

    case EDIT_TRAVEL_COMPANION:
      const editedCompanionIndex = state.list.findIndex(
        ({ companionId }) => companionId === action.payload.companionId,
      );
      state.list[editedCompanionIndex] = action.payload;
      return state;

    case SELECT_TRAVEL_COMPANION:
      const selectedCompanionIndex = state.list.findIndex(
        ({ companionId }) => companionId === action.payload.companionId,
      );
      state.list[selectedCompanionIndex].isSelected = true;
      const { parentIndex } = action.payload;

      if (!state.selectedIndexes.map(({ index }) => index).includes(parentIndex)) {
        state.selectedIndexes.push({
          index: parentIndex,
          position: action.payload.position,
        });
      }

      return state;

    case UNSELECT_TRAVEL_COMPANION:
      const unselectedCompanionIndex = state.list.findIndex(
        ({ companionId }) => companionId === action.payload.companionId,
      );
      const unselectedParentIndex = state.selectedIndexes.findIndex(
        ({ index, position }) =>
          position === action.payload.position && index === action.payload.parentIndex,
      );
      state.list[unselectedCompanionIndex].isSelected = false;

      if (unselectedParentIndex !== -1) {
        state.selectedIndexes.splice(unselectedParentIndex, 1);
      }

      return state;

    default:
      return state;
  }
};
